var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1652.508 -822.327 10 5.046"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1652.508-822.327h10l-5.046 5.046z"
  })));
}
export default SvgTriangleDown;